import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import HomeIcon from '@mui/icons-material/Home';
import ReceiptIcon from '@mui/icons-material/Receipt';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import InventoryIcon from '@mui/icons-material/Inventory';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import PersonIcon from '@mui/icons-material/Person';
import ExpandLess from '@mui/icons-material/ExpandLess';
import BarChartIcon from '@mui/icons-material/BarChart';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { styled, keyframes, fontWeight } from '@mui/system';
import { Typography } from '@mui/material';
import logo from '../AppbarAndDrawer/bizstorlogo.png';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { useNavigate } from "react-router-dom";
import AddBoxIcon from '@mui/icons-material/AddBox';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import {LayoutDashboard,AlignLeft, BoxIcon, TestTube,Bell,Undo2,ChartLine,UserRound,Newspaper,FileText,SquarePlus,PackagePlus,FileBox } from 'lucide-react';
import { useLocation } from 'react-router-dom';


const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeInAndMove = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px); // Start from above
    }
    to {
        opacity: 1;
        transform: translateY(0); // End at the original position
    }
`;

// Styled component to hide scrollbar
const CustomDrawerContent = styled(Box)(({ theme }) => ({
    width: 250,
    height: '100%',
    backgroundColor: 'white',
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    color: 'black',
    overflowY: 'auto',
    overflowX: 'hidden', // Hide horizontal scrollbar
    '&::-webkit-scrollbar': {
        width: '0px', // Hide scrollbar for WebKit browsers
    },
    scrollbarWidth: 'none', 
    msOverflowStyle: 'none', 
}));

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    width: '225px',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'hidden',

    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '0%',
        height: '100%',
        color: 'black',
        backgroundColor: 'rgb(238, 238, 238)',
        transition: 'width 0.4s ease',
        zIndex: 0,
    },

    '&:hover::before': {
        width: '100%',
    },

    '&:hover': {
        backgroundColor: 'transparent',
    },

    '& .MuiListItemText-root, & .MuiListItemIcon-root': {
        position: 'relative',
        zIndex: 1,
    },

    animation: `${slideInFromLeft} 0.7s ease-out`,
}));



const StyledListItemText = styled(ListItemText)(({ theme }) => ({
    '& .MuiTypography-root': {
        fontSize: '0.9rem',
        animation: `${slideInFromLeft} 0.7s ease-out`,
    },
}));

const AnimatedTypography = styled(Typography)(({ theme }) => ({
    animation: `${fadeInAndMove} 0.5s ease-out`,
    color: 'orange',
}));

const AnimatedImage = styled('img')(({ theme }) => ({
    width: '15%',
    height: '15%',
    borderRadius: '10%',
    animation: `${fadeInAndMove} 0.5s ease-out`, // Apply the animation
    transition: 'transform 0.3s ease', // Smooth transition for transformations
    '&:hover': {
        transform: 'scale(1.1)', // Scale image on hover
    },
}));

const subscriptionCache = {};

export default function TemporaryDrawer() {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [open, setOpen] = React.useState(false);
    const [addOpen, setAddOpen] = React.useState(false);
    const [addOpen2, setAddOpen2] = React.useState(false);
    const [userSubscription, setUserSubscription] = useState(null);
    const navigate = useNavigate();

    const location = useLocation();

    const isDashboardActive = location.pathname === '/dashboard';
    const isInvoiceActive = location.pathname === '/invoice';
    const isAllInvoiceActive = location.pathname === '/all-invoice';
    const isReturnActive = location.pathname === '/return';
    const isItemActive = location.pathname === '/items';
    const isProductionActive = location.pathname === '/production';
    const isInventoryDetailsActive = location.pathname === '/inventory-details';
    const isExpensesActive = location.pathname === '/expenses';
    const isInvestmentActive = location.pathname === '/investment';
    const isChartActive = location.pathname === '/chart';
    const reportPaths = [
        '/allreport',
        '/report-invoice',
        '/report-return-invoice',
        '/report-expenses',
        '/report-inventory',
        '/report-investment',
        '/report-summary',
        '/report-profit-loss',
        '/report-customers',
        '/report-sales-customer',
        '/report-sales-product',
        '/report-balance-sheet',
        '/report-outstanding',
        '/bank-account-history',
    ];

    const isAllReportActive = reportPaths.includes(location.pathname);
    const isAddCustomerActive = location.pathname === '/addcustomer';
    const isAddSupplierActive = location.pathname === '/addsupplier';
    const isAddProductActive = location.pathname === '/addproduct';
    const isAddExpensesActive = location.pathname === '/addexpenses';
    const isProfileActive = location.pathname === '/profile';


    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/");
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/");
                }
            }
        };

        fetchProfile();
    }, []);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const handleAddClick = (e) => {
        e.stopPropagation();
        setAddOpen((prev) => !prev);
    };

    const handleAddClick2 = (e) => {
        e.stopPropagation();
        setAddOpen2((prev) => !prev);
    };


    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

                const matchedSub = response.data.subscription
                    .filter(sub => sub.email === user.email && sub.status === "active")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                setUserSubscription(matchedSub || null);
            } catch (error) {
                console.error("Failed to fetch subscriptions", error);
            }
        };

        if (user.email) {
            fetchSubscriptions();
        }
    }, [user.email]);



    const isFreePlan = userSubscription?.plan === "free";
    const isBasicPlan = userSubscription?.plan === "basic";
    const isPremiumPlan = userSubscription?.plan === "premium";
    const is30DaysFreePlan = userSubscription?.plan === "30 days free";

    const handleNavigation = (event, shouldNavigate, path) => {
        if (!shouldNavigate) {
            event.preventDefault();
        } else if (shouldNavigate && path) {
            toggleDrawer(false);
        } else if (!shouldNavigate && path) {
            console.log("Access Denied for this plan.");
        }
    };

    const DrawerList = (
        <CustomDrawerContent role="presentation" onClick={toggleDrawer(false)}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center', // Center horizontally
                    alignItems: 'center', // Center vertically if needed
                }}
            >
                <AnimatedImage
                    src={logo}
                    alt="Logo"
                />
                <AnimatedTypography
                    variant="h6"
                    noWrap
                    component="div"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        ml: 1
                    }}
                >
                    {/** BIZSTOR*/}
                </AnimatedTypography>
            </Box>
            <List
                sx={{
                    marginTop: 2
                }}
            >

                <ListItem key="home" disablePadding>
                    <Link to="/dashboard" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <StyledListItemButton
                            onClick={toggleDrawer(false)}
                            sx={{
                                backgroundColor: isDashboardActive ? '#e0e0e0' : 'inherit',
                                '&:hover': { backgroundColor: '#f5f5f5' }
                            }}
                        >
                            <ListItemIcon sx={{ color: 'black' }}>
                                <LayoutDashboard />
                            </ListItemIcon>
                            <StyledListItemText primary="Dashboard" />
                        </StyledListItemButton>
                    </Link>
                </ListItem>

                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="invoice" disablePadding>
                        <Link
                            to="/invoice"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) =>
                                handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/invoice")
                            }
                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isInvoiceActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <ReceiptIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Invoice" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>
                )}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="All invoice" disablePadding>
                        <Link
                            to="/all-invoice"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/all-invoice")}
                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isAllInvoiceActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <FileText />
                                </ListItemIcon>
                                <StyledListItemText primary="All Invoice" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="return" disablePadding>
                        <Link
                            to="/return"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isPremiumPlan), "/return")}
                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isReturnActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <Undo2 />
                                </ListItemIcon>
                                <StyledListItemText primary="Return" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                {/**{user.email !== 'bizstoradmin@gmail.com' && (
                <ListItem key="inventory" disablePadding>
                    <Link to="/inventory" style={{ textDecoration: 'none', color: 'inherit' }}>
                        <StyledListItemButton onClick={toggleDrawer(false)}>
                            <ListItemIcon sx={{ color: 'white' }}>
                                <InventoryIcon />
                            </ListItemIcon>
                            <StyledListItemText primary="Inventory" />
                        </StyledListItemButton>
                    </Link>
                </ListItem>)}*/}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="expenses" disablePadding>
                        <Link
                            to="/expenses"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/expenses")}

                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isExpensesActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <MoneyOffIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Expenses" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="Investment" disablePadding>
                        <Link
                            to="/investment"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/investment")}
                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isInvestmentActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <AccountBalanceIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Investment" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                                    {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="add" disablePadding>
                        <StyledListItemButton
                            disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                            onClick={handleAddClick2}

                        >
                            <ListItemIcon sx={{ color: 'black' }} disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}>
                                <InventoryIcon />
                            </ListItemIcon>
                            <StyledListItemText primary="Inventory" />
                            {addOpen2 ? <ExpandLess sx={{ color: 'black', mr: 4 }} /> : <ExpandMore sx={{ color: 'black', mr: 4 }} />}
                        </StyledListItemButton>
                    </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <Collapse in={addOpen2} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem key="product" disablePadding>
                                <Link
                                    to="/product"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/product")}
                                >
                                    <StyledListItemButton
                                        onClick={(e) => e.stopPropagation()}
                                        disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isItemActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <BoxIcon />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Product" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="material" disablePadding>
                                <Link
                                    to="/material"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/material")}
                                >
                                    <StyledListItemButton
                                        onClick={(e) => e.stopPropagation()}
                                        disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isProductionActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <TestTube />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Material" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="details" disablePadding>
                                <Link
                                    to="/inventory-details"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/inventory-details")}
                                >
                                    <StyledListItemButton
                                        onClick={(e) => e.stopPropagation()}
                                        disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isInventoryDetailsActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <FileBox />
                                        </ListItemIcon>
                                        <StyledListItemText primary="details" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                        </List>
                    </Collapse>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="report" disablePadding>
                        <Link
                            to="/allreport"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/allreport")}
                        >
                            <StyledListItemButton
                                onClick={toggleDrawer(false)}
                                disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isAllReportActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <Newspaper />
                                </ListItemIcon>
                                <StyledListItemText primary="Report" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                {/**{user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="inventory-details" disablePadding>
                        <Link
                            to="/inventory-details"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/inventory-details")}
                        >
                            <StyledListItemButton disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}>
                                <ListItemIcon sx={{ color: 'white' }}>
                                    <InventoryIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Inventory Details" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}*/}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="chart" disablePadding>
                        <Link
                            to="/chart"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/chart")}
                        >
                            <StyledListItemButton
                                disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                sx={{
                                    backgroundColor: isChartActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <ChartLine />
                                </ListItemIcon>
                                <StyledListItemText primary="Chart" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}
                {/** 
                {user.email !== 'bizstoradmin@gmail.com' && (
                <ListItem key="customer" disablePadding>
                <Link to="/addcustomer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <StyledListItemButton onClick={toggleDrawer(false)}>
                        <ListItemIcon sx={{ color: 'white' }}>
                            <PersonAddIcon />
                        </ListItemIcon>
                        <StyledListItemText primary="Add Customer" />
                    </StyledListItemButton>
                    </Link>
                </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                <ListItem key="supplier" disablePadding>
                <Link to="/addsupplier" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <StyledListItemButton onClick={toggleDrawer(false)}>
                        <ListItemIcon sx={{ color: 'white' }}>
                            <PeopleIcon />
                        </ListItemIcon>
                        <StyledListItemText primary="Add Supplier" />
                    </StyledListItemButton>
                    </Link>
                </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                <ListItem key="product" disablePadding>
                <Link to="/addproduct" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <StyledListItemButton onClick={toggleDrawer(false)}>
                        <ListItemIcon sx={{ color: 'white' }}>
                            <CategoryIcon />
                        </ListItemIcon>
                        <StyledListItemText primary="Add Product" />
                    </StyledListItemButton>
                    </Link>
                </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                <ListItem key="expenses" disablePadding>
                <Link to="/addexpenses" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <StyledListItemButton onClick={toggleDrawer(false)}>
                        <ListItemIcon sx={{ color: 'white' }}>
                            <MoneyOffIcon />
                        </ListItemIcon>
                        <StyledListItemText primary="Add Expenses" />
                    </StyledListItemButton>
                    </Link>
                </ListItem>)}*/}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="add" disablePadding>
                        <StyledListItemButton onClick={handleAddClick} disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}>
                            <ListItemIcon sx={{ color: 'black' }}>
                                <AddIcon />
                            </ListItemIcon>
                            <StyledListItemText primary="Add" />
                            {addOpen ? <ExpandLess sx={{ color: 'black', mr: 3 }} /> : <ExpandMore sx={{ color: 'black', mr: 3 }} />}
                        </StyledListItemButton>
                    </ListItem>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <Collapse in={addOpen} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem key="customer" disablePadding>
                                <Link
                                    to="/addcustomer"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/addcustomer")}
                                >
                                    <StyledListItemButton
                                        disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isAddCustomerActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <PersonAddIcon />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Customer" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="supplier" disablePadding>
                                <Link
                                    to="/addsupplier"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/addsupplier")}
                                >
                                    <StyledListItemButton
                                        disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isAddSupplierActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <PeopleIcon />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Supplier" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="product" disablePadding>
                                <Link
                                    to="/addproduct"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/addproduct")}
                                >
                                    <StyledListItemButton
                                        disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isAddProductActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <PackagePlus />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Product" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="material" disablePadding>
                                <Link
                                    to="/addmaterial"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan), "/addmaterial")}
                                >
                                    <StyledListItemButton
                                        disabled={!(is30DaysFreePlan || isFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isAddProductActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <TestTube />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Material" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                            <ListItem key="expenses" disablePadding>
                                <Link
                                    to="/addexpenses"
                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                    onClick={(event) => handleNavigation(event, (is30DaysFreePlan || isBasicPlan || isPremiumPlan), "/addproduct")}
                                >
                                    <StyledListItemButton
                                        disabled={!(is30DaysFreePlan || isBasicPlan || isPremiumPlan)}
                                        sx={{
                                            pl: 4,
                                            backgroundColor: isAddExpensesActive ? '#e0e0e0' : 'inherit',
                                            '&:hover': { backgroundColor: '#f5f5f5' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ color: 'black' }}>
                                            <MoneyOffIcon />
                                        </ListItemIcon>
                                        <StyledListItemText primary="Expenses" />
                                    </StyledListItemButton>
                                </Link>
                            </ListItem>
                        </List>
                    </Collapse>)}
                {user.email !== 'bizstoradmin@gmail.com' && (
                    <ListItem key="profile" disablePadding>
                        <Link to="/profile" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <StyledListItemButton
                                onClick={toggleDrawer(false)}
                                sx={{
                                    backgroundColor: isProfileActive ? '#e0e0e0' : 'inherit',
                                    '&:hover': { backgroundColor: '#f5f5f5' }
                                }}
                            >
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <UserRound />
                                </ListItemIcon>
                                <StyledListItemText primary="Profile" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>)}

                {user.email === 'bizstoradmin@gmail.com' && (
                    <ListItem key="user-managemnt" disablePadding>
                        <Link to="/user-management" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <StyledListItemButton onClick={toggleDrawer(false)}>
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <PersonIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="User Management" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>
                )}
                {user.email === 'bizstoradmin@gmail.com' && (
                    <ListItem key="Package" disablePadding>
                        <Link to="/payments" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <StyledListItemButton onClick={toggleDrawer(false)}>
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <CreditScoreIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Package" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>
                )}
                {user.email === 'bizstoradmin@gmail.com' && (
                    <ListItem key="reports" disablePadding>
                        <Link to="/payment-reports" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <StyledListItemButton onClick={toggleDrawer(false)}>
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <SummarizeIcon />
                                </ListItemIcon>
                                <StyledListItemText primary="Payment Reports" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>
                )}
                {user.email === 'bizstoradmin@gmail.com' && (
                    <ListItem key="Notification" disablePadding>
                        <Link to="/notification" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <StyledListItemButton onClick={toggleDrawer(false)}>
                                <ListItemIcon sx={{ color: 'black' }}>
                                    <Bell />
                                </ListItemIcon>
                                <StyledListItemText primary="notification" />
                            </StyledListItemButton>
                        </Link>
                    </ListItem>
                )}
            </List>
        </CustomDrawerContent>
    );

    return (
        <div>
            <IconButton onClick={toggleDrawer(true)} color="inherit">
                <AlignLeft sx={{ color: 'orange' }} />
            </IconButton>

            <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
            </Drawer>
        </div>
    );
}
